










































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import axios from 'axios'
import { Toast } from 'vant'
import rtSelect from '@/components/estate/selectCom.vue'
const estateModule = namespace('estate')

@Component({
  components: { rtSelect }
})
export default class Assign extends Vue {
  @estateModule.State('estateAssginList') estateAssginList!: any
  timePickShow: Boolean = false // 日期picker
  minDate: any = new Date()
  currtTime: any = new Date() // 日期picker 当前时间
  searchTime: any = ''
  repairPersonId: any = ''
  repairPerson: string = ''
  mounted() {
    this.getEstateAssignList()
  }
  handleSelectPersonClick(val: any) {
    this.repairPersonId = val.accountId
    this.repairPerson = val.name
  }
  /** 日期picker 确认 */
  dateTimeSure(selectDate: any) {
    const year = selectDate.getFullYear()
    const month = selectDate.getMonth() + 1
    const day = selectDate.getDate()
    const hh = selectDate.getHours()
    const mm = selectDate.getMinutes()
    this.searchTime = `${year}-${month < 10 ? `0${month}` : month}-${
      day < 10 ? `0${day}` : day
    }  ${hh < 10 ? `0${hh}` : hh}:${mm < 10 ? `0${mm}` : mm}`
    console.log(this.searchTime)
    this.timePickShow = false
  }
  async getEstateAssignList() {
    const { error, success } = await this.$store.dispatch(
      'estate/estateAccountAssignList',
      {
        functionResource: '/estateWorker'
      }
    )
  }
  /**确认分配 */
  handleCreateClick() {
    if (this.searchTime == '' || !this.searchTime) {
      Toast('请选择计划完成时间')
      return
    }
    if (this.repairPersonId == '' || !this.repairPersonId) {
      Toast('请选择维修人员')
      return
    }
    this.estateMaintainAssign()
  }
  /**分配  商管端 */
  async estateMaintainAssign() {
    const { error, success } = await this.$store.dispatch(
      'estate/estateMaintainAssign',
      {
        expectedTime: this.searchTime + ':00',
        userId: Number(this.repairPersonId),
        id: Number(this.$route.query.id)
      }
    )
    if (success) {
      Toast('分配成功')
      this.$router.push('/estateManage')
    }
    if (error) {
      Toast(error.msg)
    }
  }
}
